import { Injectable, inject } from '@angular/core';
import { HttpService } from '@utils/http.service';
import { UtilsService } from '@utils/utils.service';

@Injectable({
  providedIn: 'root',
})
export class SettingService {
  private http = inject(HttpService);
  private utils = inject(UtilsService);

  public robotSideaList = async () => await this.http.get(`/v1/robot/sidea`).then((response: any) => response.data.content);
  public robotSideaSwitchStatus = async (id: number, status: string) => await this.http.put(`/v1/robot/sidea/${id}/switch-status`, { status: status }).then((response: any) => response.data);
  public robotSideaSetCookie = async (id: number, data: any) => await this.http.put(`/v1/robot/sidea/${id}/set-cookie`, data).then((response: any) => response.data);
  public robotSideaRebot = async (id: number) => await this.http.put(`/v1/robot/sidea/${id}/reboot`, {}).then((response: any) => response.data);
  public robotSideaCreate = async (body: any) => await this.http.post(`/v1/robot/sidea`, body).then((response: any) => response.data);
  public robotSideaDelete = async (id: number) => await this.http.delete(`/v1/robot/sidea/${id}`).then((response: any) => response.data);
}
